<template>
  <v-content>
    <v-row no-gutters>
      <v-col cols="12">
       
        <v-flex class="pb-2 ml-0">
          <v-alert dense color="primary" class="text-left" text border="left"
            >ITENS ETAPA</v-alert
          >
        </v-flex>
      </v-col>
    </v-row>

    <v-card class="pa-5" v-show="!sv">
      <v-row no-gutters>
        <v-col cols="4">
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Pesquisar"
            filled
            dense
            single-line
            hide-details
          ></v-text-field>
        </v-col>
        <v-col class="text-left" cols="4">
          <v-btn
            v-show="$can('item.create|admin.loja')"
            @click="novo()"
            color="topEnviados"
            dark
            
          >
            <v-icon>mdi-plus</v-icon>Nova
          </v-btn>
        </v-col>
      </v-row>
      <v-data-table
        :headers="headers"
        :items="items"
        :loading="loading_table"
        :footerProps="footerProps"
        loading-text="Carregando... Aguarde"
        dense
        :search="search"
        no-data-text="Nenhum resultado encontrado!"
        no-results-text="Nenhum resultado encontrado!"
        class="elevation-1"
      >
      <template v-slot:item.vincular_item="{ item }">      
        <v-icon
            v-show="$can('admin.loja|montagem_item_obs.link.cancelar')"
            color="green"
            class="mr-2"
        
            @click="vincularItem(item)"
            >link</v-icon
          >
      </template>
      <template v-slot:item.vincular="{ item }">
          <v-icon
            color="green"
            class="mr-2"
            v-show="true"
            @click="vincularProduto(item)"
            >link</v-icon
          >
        </template>
        <template v-slot:item.action="{ item }">
          <v-icon
            color="btBlue"
            class="mr-2"
            v-show="$can('item.update|admin.loja')"
            @click="editItem(item)"
            >edit</v-icon
          >
          <v-icon
            color="error"
            class="mr-2"
            v-show="$can('admin.loja|item.delete')"
            @click="deleteItem(item)"
            >delete</v-icon
          >
        </template>
      </v-data-table>
    </v-card>
    <v-dialog v-model="dialogVinculaProduto" max-width="35%">
      <v-card>
        <v-card-title class>
          <span>Adicionais</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-col cols="12" md="12" lg="12" sd="12" xs="12">
              <v-autocomplete
                dense
                chips
                small-chips
                deletable-chips
                label="Produtos vinculados"
                multiple
                :auto-select-first="true"
                v-model="produtos"
                item-value="codigo"
                item-text="descricao_reduzida"
                ref="codigo_produto"
                :items="itemsProdutos"
                @change="gravarVinculo()"
                filled
              >
              </v-autocomplete>
            </v-col>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-col cols="12" md="6" lg="6">
            <v-btn color="error" @click="dialogVinculaProduto = false">
              <v-icon>mdi-close</v-icon>Fechar
            </v-btn>
          </v-col>

          <v-col cols="12" md="6" lg="6">
            <v-btn
              v-if="cadastro == false"
              color="success"
              class="mr-4"
              @click="gravarEdicao()"
            >
              <v-icon>mdi-check</v-icon>Editar
            </v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogCadastro" persistent max-width="35%">
      <v-card>
     
        <v-card-title class>
          <span v-if="cadastro">Cadastrar Item</span>
          <span v-if="cadastro == false">Editar Item</span>
        </v-card-title>
        <v-card-text>
          <v-container>
                      
              <v-col cols="12" md="8" lg="8">
                <v-text-field
                  v-model="item.descricao"
                  label="Descrição"
                  ref="descricao_item"
                  filled
                  dense
                  clearable
                  required
                ></v-text-field>
              </v-col>
             
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-col cols="12" md="6" lg="6">
            <v-btn color="error" @click="dialogCadastro = false">
              <v-icon>mdi-close</v-icon>Fechar
            </v-btn>
          </v-col>

          <v-col cols="12" md="6" lg="6">
            <v-btn
              v-if="cadastro"
              color="success"
              class="mr-4"
              @click="gravar()"
            >
              <v-icon>mdi-check</v-icon>Gravar
            </v-btn>
            <v-btn
              v-if="cadastro == false"
              color="success"
              class="mr-4"
              @click="gravarEdicao()"
            >
              <v-icon>mdi-check</v-icon>Editar
            </v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogVinculaObsItem" persistent max-width="55%">
      <v-card>
       
        <v-card-title class>
          <span>Vincular Observação </span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" xl="4" md="4" lg="4" sd="4" xs="12">
                <v-autocomplete
                  dense
                  label="Observações"
                  :auto-select-first="true"
                  v-model="item.id"
                  item-value="id"
                  item-text="descricao"
                  ref="id_obs"
                  :items="observacoes"
                  filled
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" xl="2" md="2" lg="2" sd="1" xs="12">
                <v-autocomplete
                  dense
                  :auto-select-first="true"
                  v-model="item.ordem"
                  ref="id"
                  label="Ordem"
                  :items="obs_lista_ordem"
                  item-value="sequencia"
                item-disabled="desativado"
                item-text="sequencia"
                  filled
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" xl="2" md="2" lg="2" sd="1" xs="12">
                <v-btn color="success" x-large @click="gravarVinculoItem()">
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" xl="12" md="12" lg="12" sd="12" xs="12">
                <v-data-table
                  :headers="headersItemEtapa"
                  :items="listaItensEtapa"
                  :loading="loading_table_item"
                  :footerProps="footerProps"
                  loading-text="Carregando... Aguarde"
                  dense
                  :search="search"
                  no-data-text="Nenhum resultado encontrado!"
                  no-results-text="Nenhum resultado encontrado!"
                  class="elevation-1"
                >
                <template v-slot:item.action="{ item }">
                
                  <v-icon
                    color="error"
                    class="mr-2"
                    v-show="$can('admin.loja|etapas.delete')"
                    @click="deleteObs(item)"
                    >link_off</v-icon
                  >
                </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-col cols="12" md="6" lg="6">
            <v-btn color="error" @click="dialogVinculaObsItem = false">
              <v-icon>mdi-close</v-icon>Fechar
            </v-btn>
          </v-col>

          <v-col cols="12" md="6" lg="6">
            <v-btn
              v-if="cadastro == false"
              color="success"
              class="mr-4"
              @click="gravarItem()"
            >
              <v-icon>mdi-check</v-icon>Editar
            </v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-row justify="center">
      <v-dialog v-model="dialogCancel" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Excluir</v-card-title>
          <v-card-text>Deseja excluir essa Item?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="red darken-1"
              class="white--text"
              @click="dialogCancel = false"
              >Não</v-btn>
            <v-btn
              color="green darken-1"
              class="white--text"
              @click="deleta(selItem)"
              >Sim</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogCancelObs" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Desvincular</v-card-title>
          <v-card-text>Deseja desvincular essa Observação?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="red darken-1"
              class="white--text"
              @click="dialogCancelObs = false"
              >Não</v-btn>
            <v-btn
              color="green darken-1"
              class="white--text"
              @click="confirma_deleta_obs(selItemObs)"
              >Sim</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-snackbar
      :timeout="3000"
      :color="sucesso"
      :bottom="true"
      absolute
      :multi-line="'multi-line'"
      :vertical="'vertical'"
      v-model="snackbarSuccess"
    >
      {{ textSucesso }}
      
    </v-snackbar>

    <v-snackbar
      :timeout="3000"
      :color="error"
      :top="true"
      :multi-line="'multi-line'"
      :vertical="'vertical'"
      v-model="snackbarError"
    >
      {{ textSnack }}
     
    </v-snackbar>
  </v-content>
</template>

<script>
export default {
  props: {
    source: String,
  },
  data: () => ({
    selItemObs:null,
    obs_lista_ordem:[],
    dialogCancelObs:false,
    listaItensEtapa:[],
    loading_table_item:false,
    observacoes:null,
    listaObs:[],
    cadastro: true,
    snackbarSuccess: false,
    snackbarError: false,
    snackbar: false,
    textSucesso: "",
    textSnack: "",
    dialogVinculaObsItem:false,
    dialogVinculaProduto:false,
    sucesso: "botao_sucesso",
    error: "error",
    footerProps: { "items-per-page-options": [50, 100, 200] },
    singleLine: true,
   
    item: {
      nome:"",
      descricao: "",
     
    },
    lista_ordem:[
    1,2,3,4,5,6,7,8,9,10],
    name: "",
    autoUpdate: true,
    
    isUpdating: false,
    imageFile: [],
    file: "",
    files: "",
    produtos:[],
    filtroProduto: "Produtos ",
    sv: false,
    dialogCadastro: false,
    itensPorPagina: 25,
    items: [],
    selectItem:null,
    itemEtapa:null,
    itemsProdutos: [],
    itemsProdutosSgtVinculados: [],
    search: "",
    searchVinculados: "",
    loading_table: false,
    selProduto: "",
    itemEdit: "",
    dialogCancel: false,
    selItem: "",
    headersItemEtapa:[{ 
        text: "Ordem",
        align: "left",
        value: "ordem",
        width: "10%",
      },
      {
        text: "Observação",
        value: "descricao",
        sortable: true,
        align: "left",
        width: "50%",
      },
      {
        text: "Desvincular",
        width: "10%",
        align: "right",
        value: "action",
        sortable: false,
      }],
   
    headers: [
     
      {
        text: "Descrição",
        value: "descricao",
        sortable: true,
        align: "left",
          width:"50%",
      },
      
      {
        text: "Vincular Observação",
        value: "vincular_item",
        sortable: true,
        align: "left",
        width: "8%",
      },
      
      { text: "Ação", width:"10%",  align: "right", value: "action", sortable: false },
    ],
  }),
  watch: {
    isUpdating(val) {
      if (val) {
        setTimeout(() => (this.isUpdating = false), 3000);
      }
    },
  },
  mounted() {
    
    this.BuscaItens();
    this.buscaProdutos();
    this.listaEtapas();
    this.lista_obs();
  },
  methods: {
    gravarVinculoItemProduto() {
      var formData = new FormData();

      formData.append("produtos", this.produtos);
      formData.append("id_etapa", this.selectCardapio);
      formData.append("id_etapa_item", this.selectItem);

      axios
        .post(`/montagem/item_etapa/add_produto`, formData)
        .then((response) => {
          if (response.data.error) {
            //  this.textSnack = response.data.error;
            //  this.snackbar = true;
          } else {
            //this.buscaProdutosSgt();
            this.snackbarSuccess = true;
            this.textSucesso = response.data.msg;
          
          }
        })
        .catch((e) => {
          if (!Array.isArray(e.response.data)) {
            let itens = [];
            for (var prop in e.response.data) {
              itens.push(e.response.data[prop][0]);
            }
            this.textSnack = itens.join(" ");
            this.snackbar = true;
          } else {
            this.textSnack = e.response.error;
            this.snackbar = true;
          }
        });
    },
    buscaProdutos() {
      axios.get(`/produto/lista`).then((response) => {
        if (response.data.error) {
          //  this.textSnack = response.data.error;
          //  this.snackbar = true;
        } else {
          // this.loading_table = false;
          //this.loading_filtrar = false;
          this.itemsProdutos = response.data;
        }
      });
    },
    vinculados() {
      axios
        .get(`/montagem/etapa/produto_vinculado/` + this.selectCardapio)
        .then((response) => {
          if (response.data.error) {
            //  this.textSnack = response.data.error;
            //  this.snackbar = true;
          } else {
            this.produtos = response.data;
          }
        });
    },
    vincularProduto(item) {
      this.dialogVinculaProduto = true;
      this.selectCardapio = item.id;
      console.log(item)

      this.vinculados();
    },
    BuscaObsVinculados() {
      this.loading_table_item = true;
      axios.get(`/montagem/obs_etapa_item/lista/`+this.selectItem).then((response) => {
        if (response.data.error) {
          //  this.textSnack = response.data.error;
          //  this.snackbar = true;
        } else {
          this.loading_table_item = false;
          this.listaItensEtapa = response.data;
          this.obs_lista_ordem = response.data[0].lista_ordem
          this.item.ordem = response.data[0].ordem_selected
        }
      });
    },
    gravarVinculoItem() {
      var formData = new FormData();

      formData.append("id_etapa_item", this.selectItem);
      formData.append("id_obs", this.item.id);
      formData.append("ordem", this.item.ordem);

      axios
        .post(`/montagem/obs_etapa_item`, formData)
        .then((response) => {
          if (response.data.error) {
              this.textSnack = response.data.error;
              this.snackbar = true;
          } else {
        
            this.BuscaObsVinculados()
            this.item.id = ""
           // this.item.ordem=""
          }
        })
        .catch((e) => {
          if (!Array.isArray(e.response.data)) {
            let itens = [];
            for (var prop in e.response.data) {
              itens.push(e.response.data[prop][0]);
            }
            this.textSnack = itens.join(" ");
            this.snackbar = true;
          } else {
            this.textSnack = e.response.error;
            this.snackbar = true;
          }
        });
    },
    listaEtapas() {
      //this.loading_table = true;
      axios.get(`montagem/etapa/lista`).then((response) => {
        if (response.data.error) {
          //  this.textSnack = response.data.error;
          //  this.snackbar = true;
        } else {
          this.loading_table = false;
          this.etapas = response.data;
        }
      });
    },
    vincularItem(item) {
      this.dialogVinculaObsItem = true;
      this.selectItem = item.id;
      
      this.BuscaObsVinculados();
      // this.vinculados()
    },
    remove(item) {
      const index = this.catSel.indexOf(item.name);
      if (index >= 0) this.catSel.splice(index, 1);
    },
    novo() {
      this.dialogCadastro = true;

      this.limpaCampos();
      setTimeout(() => {
        this.$refs.descricao_item.focus()
      }, 300);
     
    },
    limpaCampos() {
      this.cadastro = true;
      this.item.descricao = "";
      
    },
    
    editItem(item) {
      this.dialogCadastro = true;
      this.cadastro = false;
      this.itemEdit = item.id;
      this.item.id = item.id;
      this.item.descricao = item.descricao;
     
     
    },
    deleteItem(item) {
      this.selItem = item.id;
      this.dialogCancel = true;
    },

    deleteObs(item) {
      this.selItemObs = item.id;
      this.dialogCancelObs = true;
    },
    deleta() {
      axios.delete(`montagem/item/`+this.selItem ).then((response) => {
        if (response.data.error) {
          this.textSnack = response.data.error;
          this.snackbarError = true;
        } else {
          this.snackbarSuccess = true;
          this.textSucesso = response.data.msg;
          this.dialogCancel = false;
          this.BuscaItens();
        }
      }).catch((e) => {
          if (e.response.data != undefined) {
            
              this.textSnack = e.response.data.error;
              this.snackbarError = true;
            }
          
        });;
    },
    async confirma_deleta_obs() {
      //alert(this.selItem);
      this.dialogCancelObs = false;
    await axios.delete(`montagem/obs_etapa_item/`+this.selItemObs+'/'+this.selectItem ).then((response) => {
        if (response.data.error) {
          this.textSnack = response.data.error;
          this.snackbarError = true;
        } else {
       
          
         // this.BuscaItens();
        }
      }).catch((e) => {
          if (e.response.data != undefined) {
            
              this.textSnack = e.response.data.error;
              this.snackbarError = true;
            }
          
        });
        this.BuscaObsVinculados()
    },
    vinculados() {
      axios.get(`/montagem/item/etapa_item_vinculado/`+this.selectItem).then((response) => {
        if (response.data.error) {
          //  this.textSnack = response.data.error;
          //  this.snackbar = true;
        } else {
          this.itemEtapa = response.data;
        }
      });
    },
    lista_obs() {
      this.loading_table = true;
      axios.get(`/montagem/obs/lista`).then((response) => {
        if (response.data.error) {
          //  this.textSnack = response.data.error;
          //  this.snackbar = true;
        } else {
          //this.loading_table = false;
          this.observacoes = response.data;
        }
      });
    },
    BuscaItens() {
      this.loading_table = true;
      axios.get(`/montagem/item/lista`).then((response) => {
        if (response.data.error) {
          //  this.textSnack = response.data.error;
          //  this.snackbar = true;
        } else {
          this.loading_table = false;
          this.items = response.data;
        }
      });
    },
    
    gravar() {
      let config = { headers: { "Content-Type": "multipart/form-data" } };
      var formData = new FormData();   
      
      formData.append("descricao", this.item.descricao);

      axios
        .post(`montagem/item`, formData, config)
        .then((response) => {
          if (response.data.error) {
            //  this.textSnack = response.data.error;
            //  this.snackbar = true;
          } else {
            //this.buscaObsSgt();
            this.snackbarSuccess = true;
            this.textSucesso = response.data.msg;
            //this.item.descricao = "";
            //this.item.ordem = "";

            this.novo();
            this.BuscaItens();
          }
        })
        .catch((e) => {
          if (e.response.data != undefined) {
            if (!Array.isArray(e.response.data)) {
              let itens = [];
              for (var prop in e.response.data) {
                itens.push(e.response.data[prop][0]);
              }
              this.textSnack = itens.join(" ");
              this.snackbarError = true;
            } else {
              this.textSnack = e.response.error;
              this.snackbarError = true;
            }
          }
        });
    },
    gravarEdicao() {
      let config = { headers: { "Content-Type": 'multipart/form-data' } };
      var formData = new FormData();
      formData.append("id", this.item.id);
      
      formData.append("descricao", this.item.descricao);

      axios
        .post(`/montagem/item/editar`, formData, config)
        .then((response) => {
          if (response.data.error) {
            //  this.textSnack = response.data.error;
            //  this.snackbar = true;
          } else {
            //this.buscaObsSgt();
            this.snackbarSuccess = true;
            this.textSucesso = response.data.msg;
            this.limpaCampos();
            this.dialogCadastro = false;
            this.BuscaItens();
          }
        })
        .catch((e) => {
          if (!Array.isArray(e.response.data)) {
            let itens = [];
            for (var prop in e.response.data) {
              itens.push(e.response.data[prop][0]);
            }
            this.textSnack = itens.join(" ");
            this.snackbar = true;
          } else {
            this.textSnack = e.response.error;
            this.snackbar = true;
          }
        });
    },

    buscaEtapasItem() {
      axios.get(`/montagem/etapa_item/lista`).then((response) => {
        if (response.data.error) {
          //  this.textSnack = response.data.error;
          //  this.snackbar = true;
        } else {
          // this.loading_table = false;
          //this.loading_filtrar = false;
          this.itemsProdutos = response.data;
        }
      });
    },
  },
};
</script>
<style scoped>
.v-input--selection-controls {
  padding: 5px !important;
  margin-bottom: 5px !important;
  margin-top: 16px;
  padding-top: 4px;
}
.v-data-table td {
  font-size: 0.685rem !important;
}
</style>
